// the units field may be set on a property if the asset type is one of the following

export default {
  "28adf474-4719-11e9-a208-0242ac140002": "MULTIFAMILY",
  "28adee52-4719-11e9-a208-0242ac140002": "MIXED_USE",
  "28adf3d0-4719-11e9-a208-0242ac140002": "STUDENT_HOUSING",
  "28adf28d-4719-11e9-a208-0242ac140002": "SENIOR_LIVING",
  "28adf151-4719-11e9-a208-0242ac140002": "HOTEL",
  "28adf0b5-4719-11e9-a208-0242ac140002": "CONDO"
};
